import {
  Card,
  CardContent,
  CardHeader,
  Container,
  TextField,
  Typography,
  Button,
  Unstable_Grid2 as Grid,
  Checkbox,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Alert,
} from "@mui/material";
import { useEffect, useState, useCallback, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  AddJozve,
  EditJozve,
  GetJozveById,
  getRules,
  PriceGhavanin,
} from "Services/Student";
import { Alert as Modal } from "utils/alerts";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import InfoIcon from "@mui/icons-material/Info";
import { Trans, useTranslation } from "react-i18next";
const AddFile = () => {
  const navigate = useNavigate();
  const { idstruser, type } = useSelector(
    (state) => state["Admin"].userInfo || {}
  );
  const [rulesOpen, setRulesOpen] = useState(false);
  const [priceOpen, setPriceOpen] = useState(false);
  const [rules, setRules] = useState([]);
  const [priceRule, setPriceRules] = useState([]);
  const [searchParams] = useSearchParams();
  const jozveId = searchParams.get("id");
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    getValues,
    clearErrors,
    setError,
    watch,
    control,
  } = useForm({
    defaultValues: {
      namejozve: "",
      teachername: "",
      universityname: "",
      price: "",
      termsAccepted: false,
      file: null,
    },
  });

  const inputRef = useRef(null);

  useEffect(() => {
    const fetchJozve = async () => {
      if (jozveId) {
        try {
          const response = await GetJozveById(jozveId);
          const jozve = response.data;
          setValue("namejozve", jozve.namejozve || "");
          setValue("teachername", jozve.teachername || "");
          setValue("price", jozve.price || "");
          setValue("file", jozve.file || "");
          setValue("universityname", jozve.universityname || "");
          setValue("termsAccepted", true);
          if (jozve.pathjozve) {
            setFileUrl(jozve.pathjozve);
            setFile({ name: jozve.namejozve || "Existing file" });
          }
        } catch (error) {
          Modal(t("newFile.error"), t("newFile.errorLoading"), "error");
        }
      }
    };

    fetchJozve();
  }, [jozveId, setValue]);
  useEffect(() => {
    const fetchRules = async () => {
      try {
        const response = await getRules();
        setRules(response.data);
      } catch (error) {
        console.error("Error fetching rules:", error);
      }
    };

    if (rulesOpen) {
      fetchRules(); // only fetch if modal is opening
    }
  }, [rulesOpen]);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await PriceGhavanin();
        setPriceRules(response.data);
      } catch (error) {
        console.error("Error fetching rules:", error);
      }
    };

    if (priceOpen) {
      fetchPrice(); // only fetch if modal is opening
    }
  }, [priceOpen]); // ✅ fix here

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      if (fileUrl && fileUrl.startsWith("blob:")) {
        URL.revokeObjectURL(fileUrl);
      }

      if (fileRejections.length > 0) {
        const error = fileRejections[0].errors[0];
        const message =
          error.code === "file-invalid-type"
            ? t("newFile.fileType")
            : error.code === "file-too-large"
            ? t("newFile.fileSize")
            : error.message;
        setError("file", { type: "manual", message });
        setFile(null);
        setFileUrl("");
        setValue("file", null);
        return;
      }

      const newFile = acceptedFiles[0];
      if (newFile) {
        clearErrors("file");
        setFile(newFile);
        setValue("file", newFile);
        const newFileUrl = URL.createObjectURL(newFile);
        setFileUrl(newFileUrl);
      }
    },
    [fileUrl, setValue, setError, clearErrors]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "application/pdf": [".pdf"] },
    maxSize: 50 * 1024 * 1024,
    onDrop,
    multiple: false,
  });

  const handleDropzoneClick = () => {
    if (inputRef.current) {
      inputRef.current.value = null; // ✅ allow re-uploading same file
      inputRef.current.click();
    }
  };

  useEffect(() => {
    return () => {
      if (fileUrl && fileUrl.startsWith("blob:")) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  const handleRemoveFile = () => {
    if (fileUrl && fileUrl.startsWith("blob:")) {
      URL.revokeObjectURL(fileUrl);
    }
    setFile(null);
    setFileUrl("");
    setValue("file", null);
    setError("file", { type: "required", message: t("newFile.fileRequired") });
  };

  const handleAddJozve = async (data) => {
    if (!data.termsAccepted) {
      setError("termsAccepted", {
        type: "required",
        message: t("newFile.termRequired"),
      });
      return;
    }

    if (!data.file && !jozveId) {
      setError("file", {
        type: "required",
        message: t("newFile.fileRequired"),
      });
      return;
    }

    const formData = new FormData();
    formData.append("idstruser", idstruser || "");
    formData.append("namejozve", data.namejozve);
    formData.append("universityname", data.universityname);
    formData.append("price", data.price);
    formData.append("teachername", data.teachername);
    formData.append("file", data.file || "");

    if (jozveId) {
      formData.append("idstrjozve", jozveId);
    }

    const showProgressBar = () => {
      Swal.fire({
        title: t("newFile.loadingFile"),
        html: `
          <div id="progress-bar" style="width: 100%; background: #f1f1f1; border-radius: 5px; height: 15px; margin-top: 10px;">
            <div id="progress-fill" style="height: 100%; width: 0; background-color: #4caf50; border-radius: 5px;"></div>
          </div>
          <p id="progress-percentage" style="margin-top: 10px;">0%</p>
        `,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
    };

    const updateProgressBar = (percentage) => {
      const fill = document.getElementById("progress-fill");
      const label = document.getElementById("progress-percentage");
      if (fill) fill.style.width = `${percentage}%`;
      if (label) label.innerText = `${percentage}%`;
    };
    try {
      setIsUploading(true);
      showProgressBar();

      const onProgress = (percentage) => {
        updateProgressBar(percentage);
      };

      if (jozveId) {
        const confirmResult = await Swal.fire({
          confirmButtonColor: "#eb4034",
          title: t("newFile.editDialogTitle"),
          text: t("newFile.editDialogText"),
          icon: "question",
          showCancelButton: true,
          confirmButtonText: t("newFile.editDialogConfirm"),
          cancelButtonText: t("newFile.editDialogCancel"),
        });

        if (confirmResult.isConfirmed) {
          await EditJozve(formData, onProgress);
          Swal.close(); // Close progress modal
          Modal(
            t("newFile.editDialogConfirm"),
            t("newFile.editSuccess"),
            "success"
          );
          navigate(-1);
        } else {
          setIsUploading(false);
          Swal.close();
          return;
        }
      } else {
        await AddJozve(formData, onProgress);
        Swal.close(); // Close progress modal
        Modal(
          t("newFile.editDialogConfirm"),
          t("newFile.addSuccess"),
          "success"
        );
        navigate(-1);
      }
    } catch (error) {
      Swal.close();
      const errorMessage =
        error?.response?.data?.message || t("newFile.errorProcessing");
      Modal(t("newFile.error"), errorMessage, "error");
    } finally {
      setIsUploading(false);
    }
  };
  return (
    <Container maxWidth="lg">
      <Card>
        {type === 2 ? (
          <>
            <CardHeader
              className="!text-[30px]"
              title={jozveId ? t("newFile.editTitle") : t("newFile.title")}
            />
            <CardContent>
              <form
                className="flex flex-col gap-4"
                onSubmit={handleSubmit(handleAddJozve)}
              >
                <Grid container spacing={4}>
                  <Grid xs={12} md={4}>
                    <TextField
                      fullWidth
                      id="namejozve"
                      label={t("newFile.name")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      {...register("namejozve", {
                        required: t("newFile.nameRequired"),
                        minLength: { value: 3, message: t("newFile.nameMin") },
                        maxLength: { value: 50, message: t("newFile.nameMax") },
                      })}
                      error={!!errors.namejozve}
                      helperText={errors.namejozve?.message}
                    />
                  </Grid>
                  <Grid xs={12} md={4}>
                    <TextField
                      fullWidth
                      id="teachername"
                      label={t("newFile.professor")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      {...register("teachername", {
                        required: t("newFile.professorRequired"),
                        minLength: { value: 3, message: t("newFile.nameMin") },
                        maxLength: { value: 50, message: t("newFile.nameMax") },
                      })}
                      error={!!errors.teachername}
                      helperText={errors.teachername?.message}
                    />
                  </Grid>
                  <Grid xs={12} md={4}>
                    <TextField
                      fullWidth
                      id="universityname"
                      label={t("newFile.uni")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      {...register("universityname", {
                        required: t("newFile.uniRequired"),
                      })}
                      error={!!errors.universityname}
                      helperText={errors.universityname?.message}
                    />
                  </Grid>
                  <Grid xs={11} md={4} sx={{ placeSelf: "center" }}>
                    <TextField
                      type="number"
                      sx={{ width: "100%" }}
                      id="outlined-basic"
                      label={t("newFile.price")}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={!!errors.price}
                      helperText={t("newFile.currency")}
                      {...register("price", {
                        required: t("newFile.priceRequired"),
                        min: {
                          value: 1,
                          message: t("newFile.priceMin"),
                        },
                        validate: (value) =>
                          Number.isInteger(Number(value)) ||
                          t("newFile.priceInt"),
                      })}
                    />
                    <IconButton
                      color="warning"
                      onClick={(e) => {
                        e.stopPropagation(); // ✅ prevent checkbox toggle
                        setPriceOpen(true);
                      }}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      <Paper
                        {...getRootProps()}
                        onClick={handleDropzoneClick}
                        sx={{
                          p: 3,
                          border: "2px dashed",
                          borderColor: isDragActive
                            ? "primary.main"
                            : "grey.300",
                          backgroundColor: isDragActive
                            ? "action.hover"
                            : "background.paper",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "action.hover",
                          },
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <input
                          {...getInputProps({
                            onChange: (e) => {
                              const file = e.target.files?.[0];
                              if (file) {
                                onDrop([file], []); // simulate dropzone drop
                              }
                            },
                          })}
                          ref={inputRef}
                        />
                        <CloudUploadIcon
                          sx={{ fontSize: 48, color: "primary.main" }}
                        />
                        <Typography variant="h6" align="center">
                          {isDragActive
                            ? t("newFile.fileDropOnly")
                            : t("newFile.fileDropHere")}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          align="center"
                        >
                          {t("newFile.fileLimit")}
                        </Typography>
                      </Paper>

                      {file && (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ color: "green", textDecoration: "underline" }}
                          >
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {file.name}
                            </a>
                          </Typography>
                          <IconButton
                            onClick={handleRemoveFile}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      )}

                      {errors.file && (
                        <Typography variant="body2" sx={{ color: "red" }}>
                          {errors.file.message.toString()}
                        </Typography>
                      )}
                    </Box>
                  </Grid>

                  <Grid xs={12}>
                    <Controller
                      name="termsAccepted"
                      control={control}
                      rules={{
                        required: t("newFile.termRequired"),
                      }}
                      render={({ field }) => (
                        <Checkbox
                          {...field}
                          checked={field.value}
                          onChange={(e) => field.onChange(e.target.checked)}
                        />
                      )}
                    />

                    <Typography component="span" dir="rtl">
                      <Trans
                        i18nKey="newFile.termsWithLabel"
                        components={{
                          label: (
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setRulesOpen(true);
                              }}
                              style={{
                                color: "#512c63",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            />
                          ),
                        }}
                      />
                    </Typography>
                    {errors.termsAccepted && (
                      <Typography variant="body2" sx={{ color: "red" }}>
                        {errors.termsAccepted.message}
                      </Typography>
                    )}
                  </Grid>

                  <Grid
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      className="!text-[20px] !py-1"
                      color={jozveId ? "warning" : "success"}
                      sx={{ width: "200px", mt: 2 }}
                      disabled={isUploading || isSubmitting}
                    >
                      {isUploading
                        ? t("newFile.processing")
                        : jozveId
                        ? t("newFile.edit")
                        : t("newFile.submit")}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </>
        ) : (
          <Box
            p={4}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {t("profileNotVerified.title")}
            </Typography>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              {t("profileNotVerified.desc")}
            </Typography>
            <Button variant="outlined" onClick={() => navigate("/profile")}>
              {t("profileNotVerified.complete")}
            </Button>
          </Box>
        )}
      </Card>
      <Dialog
        open={rulesOpen}
        onClose={() => setRulesOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{t("rulesDialog.title")}</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: "675px" }}>
          {rules.length > 0 ? (
            <ul style={{ listStyleType: "disc", paddingRight: "30px" }}>
              {rules.map((rule, idx) => (
                <li key={idx} style={{ marginBottom: "12px" }}>
                  <Typography
                    variant="body1"
                    sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {rule.textghavanin}
                  </Typography>
                </li>
              ))}
            </ul>
          ) : (
            <Typography variant="body2">{t("rulesDialog.loading")}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRulesOpen(false)} variant="contained">
            {t("rulesDialog.close")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={priceOpen}
        onClose={() => setPriceOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{t("priceDialog.title")}</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: "675px" }}>
          {priceRule.length > 0 ? (
            <ul style={{ listStyleType: "disc", paddingRight: "30px" }}>
              {priceRule.map((rule, idx) => (
                <li key={idx} style={{ marginBottom: "12px" }}>
                  <Typography
                    variant="body1"
                    sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                  >
                    {rule.comment}
                  </Typography>
                </li>
              ))}
            </ul>
          ) : (
            <Typography variant="body2">{t("priceDialog.loading")}</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPriceOpen(false)} variant="contained">
            {t("priceDialog.close")}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AddFile;
